"use client";

import type { ResolvedCollection } from "../../hooks/useLifestyleCollections";

interface CollectionListProps {
  /** Matches the aria-controls of the tab that opens this panel. */
  id: string;
  collections: ResolvedCollection[];
  onSelect: (collectionId: number) => void;
}

/**
 * The Collections panel. These are jump links, not filters — picking one
 * scrolls the page to that carousel row — so there is no selected state and no
 * "All collections" reset.
 *
 * The design fills three columns top-to-bottom rather than left-to-right, so
 * this uses CSS multi-column instead of a grid, collapsing to one on mobile.
 */
export default function CollectionList({ id, collections, onSelect }: CollectionListProps) {
  return (
    <div id={id} role="tabpanel" className="columns-1 lg:columns-3 gap-6">
      {collections.map(collection => (
        <button
          key={collection.id}
          type="button"
          onClick={() => onSelect(collection.id)}
          className="flex items-center w-full min-h-11 py-[11px] font-roboto text-base text-left leading-5.5 text-dark-1 break-words break-inside-avoid hover:text-primary transition-colors">
          {collection?.displayName?.[0] + collection.displayName?.slice(1).toLowerCase()}
        </button>
      ))}
    </div>
  );
}
